/**
 * @flow
 */

const cache = {};

/**
 * Detect storage availability.
 */
function storageAvailable(type: string): boolean {
  if (type in cache) {
    return cache[type];
  }

  try {
    const storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    cache[type] = true;
    return true;
  }
  catch (e) {
    cache[type] = false;
    return false;
  }
}

/**
 * Save data to storage.
 */
export function set(key: string, value: any): boolean {
  if (!storageAvailable('localStorage')) {
    return false;
  }

  localStorage.setItem(key, JSON.stringify(value));
  return true;
}

/**
 * Retrieve data from storage.
 */
export function get(key: string): any {
  if (!storageAvailable('localStorage')) {
    return;
  }

  const item = window.localStorage.getItem(key);

  if (!item) {
    return;
  }

  return JSON.parse(item);
}

/**
 * Remove data from storage.
 */
export function remove(key: string): void {
  window.localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/lib/storage.js